module.exports = __webpack_public_path__ + "img/k4.c57cd706.webp";